/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  var ReusableMap, d3Queue, featureFlagHelpers, format_numbers, helperFunctions, isFeatureEnabled, topojson,
    indexOf = [].indexOf;

  require("jquery-ui/ui/widgets/tooltip");

  featureFlagHelpers = require("shared/featureflags/helperFunctions.js");

  isFeatureEnabled = featureFlagHelpers.isFeatureEnabled;

  d3Queue = require("d3-queue");

  topojson = require("topojson");

  helperFunctions = require("shared/imports/sharedHelperFunctions");

  ReusableMap = function(qdt = void 0, colorConfig = {}) {
    var MapCScale, all_regions, api_key, data, data_dict, district, district_borders_g, district_tag, districts, districts_g, draw_map, extent, fipsid_to_state, getColor, height, highlight_color, id_to_state, inactive_color, isInArray, is_state, legend, legend_label, load_data, lowerRangeColor, map, mapColor, margin, non_selected_color, one_district, path, pinpoint_stroke, projection, region_to_num, region_to_num_key, reset_zoom, selected_district, selected_legislators, selected_state, selected_state_color, selected_state_ids, session_num, show_max, show_min, show_total, state, state_color_aux, state_color_default, state_mapping, state_num, states_borders_g, states_g, svg, text_adj, text_fill_adj, tip, update, upperRangeColor, us, width, wrapper_g, zoom;
    // global variables
    margin = null;
    width = null;
    height = null;
    // Region string to number converter
    region_to_num_key = qdt !== DjangIO.app.models.QuorumDataType.person.value ? "value" : "database_id";
    region_to_num = DjangIO.app.models.Region.items().filter(function(item) {
      return item.is_single_us_state && item.key !== "federal";
    }).reduce(function(acc, curr) {
      var abbrev, value;
      abbrev = curr.abbrev;
      value = curr[region_to_num_key];
      return Object.assign({}, acc, {
        [`${abbrev}`]: value
      });
    }, {});
    show_total = 18;
    show_min = 0;
    show_max = show_total;
    id_to_state = {};
    fipsid_to_state = {};
    highlight_color = '#503ABD';
    non_selected_color = '#aaa';
    selected_state_color = '#4D2D5F';
    state_color_default = '#fff'; //white
    state_color_aux = '#7b8a8b'; //dark gray
    pinpoint_stroke = '#fff'; //white
    inactive_color = "#AAAAAA";
    // repub_color = '#d62728'         #red
    // dem_color = '#1f77b4'           #blue
    // ind_color = '#8c564b'           #brown

    // allow for passing custom colors
    lowerRangeColor = '#A7B2CC';
    upperRangeColor = '#503ABD';
    if (colorConfig['primaryColor']) {
      upperRangeColor = d3.rgb(colorConfig['primaryColor']).darker(4);
      lowerRangeColor = colorConfig['primaryColor'];
    }
    selected_state_color = colorConfig['secondaryColor'] || '#4D2D5F';
    MapCScale = d3.scale.linear().range([lowerRangeColor, upperRangeColor]);
    legend_label = function(data_type) {
      var ref;
      return 'Number of ' + ((ref = DjangIO.app.models.QuorumDataType.by_value(data_type)) != null ? ref.plural : void 0);
    };
    mapColor = function(val) {
      if (val === 0) {
        return '#b4bcc2';
      } else {
        return MapCScale(val);
      }
    };
    // adjustments for state labels
    text_adj = null;
    // state text fill adjustments for CT, DE, DC, HI, MD MA, NH, NJ, RI, VT
    text_fill_adj = [9, 10, 11, 15, 24, 25, 33, 34, 44, 50];
    // single-district states AK, DE, DC, MT, ND, SD, VT, WY
    one_district = [200, 1000, 1198, 3000, 3800, 4600, 5000, 5600];
    // API key for Sunlight Foundation district locating
    api_key = "bee26b52d4974d7683db2000ae00ec63";
    // svg groups for axes, etc.
    svg = null;
    wrapper_g = null;
    states_g = null;
    states_borders_g = null;
    districts_g = null;
    district_borders_g = null;
    tip = null;
    is_state = false;
    state_num = "";
    all_regions = true;
    // datasets
    us = null;
    state_mapping = {};
    districts = null;
    selected_legislators = [];
    data = null;
    // variables that reflect the current state of the visualization
    session_num = $("#votes-table").data("storage");
    state = '';
    district = '';
    selected_state = null;
    selected_state_ids = [];
    selected_district = null;
    district_tag = '';
    extent = [];
    data_dict = null;
    path = null;
    projection = null;
    // initialize visualization
    map = function(selection, margin_in, width_in, height_in) {
      var active_view, legend_html, legend_keys;
      margin = margin_in;
      width = width_in;
      height = height_in;
      projection = d3.geo.albersUsa().scale(2 * height).translate([width / 2, height / 2.02]);
      path = d3.geo.path().projection(projection);
      // take in data and min/max of counts
      data = [
        {
          "state": "al",
          "value": 0
        },
        {
          "state": "ak",
          "value": 0
        },
        {
          "state": "az",
          "value": 0
        },
        {
          "state": "ar",
          "value": 0
        },
        {
          "state": "ca",
          "value": 0
        },
        {
          "state": "co",
          "value": 0
        },
        {
          "state": "ct",
          "value": 0
        },
        {
          "state": "de",
          "value": 0
        },
        {
          "state": "dc",
          "value": 0
        },
        {
          "state": "fl",
          "value": 0
        },
        {
          "state": "ga",
          "value": 0
        },
        {
          "state": "hi",
          "value": 0
        },
        {
          "state": "id",
          "value": 0
        },
        {
          "state": "il",
          "value": 0
        },
        {
          "state": "in",
          "value": 0
        },
        {
          "state": "ia",
          "value": 0
        },
        {
          "state": "ks",
          "value": 0
        },
        {
          "state": "ky",
          "value": 0
        },
        {
          "state": "la",
          "value": 0
        },
        {
          "state": "me",
          "value": 0
        },
        {
          "state": "md",
          "value": 0
        },
        {
          "state": "ma",
          "value": 0
        },
        {
          "state": "mi",
          "value": 0
        },
        {
          "state": "mn",
          "value": 0
        },
        {
          "state": "ms",
          "value": 0
        },
        {
          "state": "mo",
          "value": 0
        },
        {
          "state": "mt",
          "value": 0
        },
        {
          "state": "ne",
          "value": 0
        },
        {
          "state": "nv",
          "value": 0
        },
        {
          "state": "nh",
          "value": 0
        },
        {
          "state": "nj",
          "value": 0
        },
        {
          "state": "nm",
          "value": 0
        },
        {
          "state": "ny",
          "value": 0
        },
        {
          "state": "nc",
          "value": 0
        },
        {
          "state": "nd",
          "value": 0
        },
        {
          "state": "oh",
          "value": 0
        },
        {
          "state": "ok",
          "value": 0
        },
        {
          "state": "or",
          "value": 0
        },
        {
          "state": "pa",
          "value": 0
        },
        {
          "state": "pr",
          "value": 0
        },
        {
          "state": "ri",
          "value": 0
        },
        {
          "state": "sc",
          "value": 0
        },
        {
          "state": "sd",
          "value": 0
        },
        {
          "state": "tn",
          "value": 0
        },
        {
          "state": "tx",
          "value": 0
        },
        {
          "state": "ut",
          "value": 0
        },
        {
          "state": "vt",
          "value": 0
        },
        {
          "state": "va",
          "value": 0
        },
        {
          "state": "wa",
          "value": 0
        },
        {
          "state": "wv",
          "value": 0
        },
        {
          "state": "wi",
          "value": 0
        },
        {
          "state": "wy",
          "value": 0
        }
      ];
      text_adj = {
        6: [
          width,
          30 //CA
        ],
        9: [
          30,
          30 //CT
        ],
        10: [
          30,
          50 //DE
        ],
        11: [
          11,
          50 //DC
        ],
        12: [
          80,
          100 //FL
        ],
        15: [
          45,
          -height //HI
        ],
        21: [
          100,
          height //KY
        ],
        22: [
          -100,
          -height //LA
        ],
        24: [
          20,
          20 //MD
        ],
        25: [
          25,
          -100 //MA
        ],
        26: [
          80,
          17 //MI
        ],
        33: [
          20,
          2500 //NH
        ],
        34: [
          30,
          100 //NJ
        ],
        36: [
          120,
          height //NY
        ],
        44: [
          25,
          100 //RI
        ],
        47: [
          width,
          90 //TN
        ],
        50: [
          -100,
          -20 //VT
        ]
      };
      extent = d3.extent(data, function(d) {
        // don't count overall US total
        if (d.state === 'us') {
          return 0;
        } else {
          return +d.value;
        }
      });
      // set choropleth scale to extent of data
      MapCScale.domain(extent);
      // a "dictionary" of state-counts, accessed by state
      data_dict = data.toDict('state');
      // make the svg object and add a rectangle for zooming
      svg = d3.select(`#${selection}`).append("svg").attr("width", width).attr("height", height).attr("id", "advanced-search-map-svg");
      svg.append("rect").attr("class", "adv-src-background").attr("width", width).attr("height", height);
      // make an svg group to go around the whole map to allow for zooming
      wrapper_g = svg.append("g");
      // initialize tooltips
      tip = d3.tip().attr('class', 'd3-tip').offset([0, 0]).html(function(d) {
        var this_dict;
        this_dict = data_dict[id_to_state[d.id].toLowerCase()];
        if (this_dict != null) {
          return id_to_state[d.id] + ': ' + this_dict['value'].toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        } else {
          return id_to_state[d.id] + ': 0';
        }
      });
      svg.call(tip);
      active_view = 'sldu';
      d3.select("#legend-label").append('text').text(legend_label(qdt));
      // make legend
      legend_html = d3.select("#legend-space-adv-src").append("ul").attr("class", "list-inline-adv-src");
      // More legend stuff
      legend_keys = legend_html.selectAll("li.key-adv-src").data([1, 2, 3, 4, 5]).enter().append("li").attr('id', function(d) {
        return 'quantile_' + String(d);
      }).attr("class", "key-adv-src").style("height", String(Math.floor(2 * height / 15)) + 'px');
      // define a queue to load in all the data, which will eventually draw e  verything
      return d3Queue().defer(d3.json, helperFunctions.generateStaticUrl("data/maps/us.static")).defer(d3.json, helperFunctions.generateStaticUrl((isFeatureEnabled("ff_district_tab_map_congress_116_file")) ? "data/maps/us-congress-116.static" : "data/maps/us-congress-113.static")).defer(d3.json, helperFunctions.generateStaticUrl("data/maps/fips_mapping.static")).defer(d3.json, helperFunctions.generateStaticUrl("data/maps/top_735_cities_0.static")).await(load_data);
    };
    // data loading function
    load_data = function(error, state_data, district_data, fips_mapping_data, top_735_cities) {
      var key, top_cities;
      us = state_data;
      districts = district_data;
      state_mapping = fips_mapping_data;
      top_cities = top_735_cities;
      for (key in fips_mapping_data) {
        id_to_state[+fips_mapping_data[key]] = key;
      }
      // draw the map
      return draw_map();
    };
    // function that draws the initial states
    draw_map = function() {
      var state_g;
      svg.append("defs").append("path").attr("id", "land").datum(topojson.feature(us, us.objects.land)).attr("d", path);
      // .on('mouseover', tip.show)
      // .on('mouseout', tip.hide)

      // clip around the given object to make sure districts don't exceed the edges
      svg.append("clipPath").attr("id", "clip-land").append("use").attr("xlink:href", "#land");
      // add another svg group for the states
      wrapper_g.attr("transform", "translate(0,0)");
      states_g = wrapper_g.append("g").attr("class", "states");

      state_g = states_g.selectAll("g").data(topojson.feature(us, us.objects.states).features).enter().append("g").classed("state", true).attr("class", function(d) {
        return d3.select(this).attr("class") + " " + id_to_state[d.id].toUpperCase();
      }).on('click', function(d) {
        var idx, j, len, selected_id, temp, val;
        selected_state = this.getAttribute("class").split(" ")[1].toLowerCase();
        selected_id = region_to_num[`${selected_state}`];
        if (isInArray(selected_id, selected_state_ids)) {
          d3.select(this).classed('clicked', false);
          // d3.select(this).style('fill', 'rgb(180, 188, 194)')
          temp = [];
          for (idx = j = 0, len = selected_state_ids.length; j < len; idx = ++j) {
            val = selected_state_ids[idx];
            if (val !== selected_id) {
              temp.push(val);
            }
          }
          selected_state_ids = temp;
        } else {
          d3.select(this).classed('clicked', true);
          selected_state_ids.push(selected_id);
        }
        if (window.state_click_callback) {
          return window.state_click_callback(d3.event);
        }
      }).style("fill", function(d) {
        return getColor(d.id);
      }).classed('clicked', function(d) {
        var current_id, current_state;
        current_state = this.getAttribute("class").split(" ")[1].toLowerCase();
        current_id = region_to_num[`${current_state}`];
        if (isInArray(current_id, selected_state_ids)) {
          return true;
        } else {
          return false;
        }
      });
      state_g.append("path").attr("d", path).attr("id", function(d) {
        return 'id_' + String(d.id);
      }).attr("data-cy", function(d) {
        return 'state_map_' + String(d.id);
      });
      // adjusts state labels based on screen size, stays proportional
      state_g.append("text").text(function(d) {
        if (id_to_state[d.id] !== "DC") {
          return id_to_state[d.id];
        } else {
          return "";
        }
      }).attr("x", function(d) {
        if (d.id in text_adj) {
          return path.centroid(d)[0] + width / text_adj[d.id][0];
        } else {
          if (isNaN(path.centroid(d)[0])) {
            return [0, 0];
          }
          return path.centroid(d)[0];
        }
      }).attr("y", function(d) {
        if (d.id in text_adj) {
          return path.centroid(d)[1] + height / text_adj[d.id][1];
        } else {
          if (isNaN(path.centroid(d)[1])) {
            return [0, 0];
          }
          return path.centroid(d)[1];
        }
      }).attr("text-anchor", "middle").attr("font-size", "0.8em").style('pointer-events', 'none').style("fill", function(d) {
        var ref;
        if (ref = d.id, indexOf.call(text_fill_adj, ref) >= 0) {
          return state_color_aux;
        } else {
          return state_color_default;
        }
      });
      state_g.attr("count", function(d) {
        if (data_dict[id_to_state[d.id].toLowerCase()] != null) {
          return data_dict[id_to_state[d.id].toLowerCase()]['value'];
        } else {
          return 0;
        }
      }).on('mouseenter', tip.show).on('mouseleave', tip.hide);
      // now add the state borders
      states_borders_g = wrapper_g.append("path").datum(topojson.mesh(us, us.objects.states, function(a, b) {
        return a !== b;
      })).attr("class", "state-borders").attr("d", path);
      return legend();
    };
    // $('#map-loading').fadeOut()
    update = function(new_label) {
      if (!states_g) {
        states_g = d3.select(".states");
      }
      states_g.selectAll("g").style("fill", function(d) {
        if (d3.select(this).classed('clicked')) {
          return selected_state_color;
        }
        return getColor(d.id);
      });
      return legend(new_label);
    };
    // zooming functions from http://bl.ocks.org/mbostock/4699541
    zoom = function(d) {
      var bounds, dx, dy, scale, translate, x, y;
      if (d == null) {
        return reset_zoom();
      } else {
        selected_state = d;
        state = id_to_state[selected_state.id];
        // zoom to the centroid of the state keeping it within the bounds
        bounds = path.bounds(d);
        dx = bounds[1][0] - bounds[0][0];
        dy = bounds[1][1] - bounds[0][1];
        x = (bounds[0][0] + bounds[1][0]) / 2;
        y = (bounds[0][1] + bounds[1][1]) / 2;
        scale = .9 / Math.max(dx / width, dy / height);
        translate = [width / 2 - scale * x, height / 2 - scale * y];
        return wrapper_g.attr("transform", "translate(" + translate + ")scale(" + scale + ")");
      }
    };
    reset_zoom = function() {
      selected_state = null;
      selected_district = null;
      state = '';
      district = '';
      // hide zoom-out button
      d3.select(".zoom-btn").style("display", "none");
      d3.select(".currently-selected").html('');
      wrapper_g.transition().duration(750).attr("transform", "");
      return wrapper_g.selectAll(".state, .state path").classed("active", false);
    };
    // Sets the color for the object, given state id
    getColor = function(id) {
      var e;
      try {
        return mapColor(data_dict[id_to_state[id].toLowerCase()]['value']);
      } catch (error1) {
        // ...
        e = error1;
        return mapColor(0);
      }
    };
    // Updates legend
    legend = function(new_label) {
      var diff, quantile;
      // Makes the legend for the map
      quantile = [1, .75, .5, .25, 0];
      diff = extent[1] - extent[0];
      d3.selectAll(".key-adv-src").style("border-left-color", function(d, i) {
        return mapColor(extent[0] + diff * quantile[i]);
      }).text(function(d, i) {
        var num_digits;
        return format_numbers(extent[0] + diff * quantile[i], num_digits = 0);
      });
      if (new_label) {
        d3.select("#legend-label").text(legend_label(new_label));
      }
    };
    isInArray = function(value, array) {
      return array.indexOf(value) > -1;
    };
    map.reset = function() {
      return reset_zoom();
    };
    map.update_data = function(new_data, new_label) {
      data = new_data;
      // take in data and min/max of counts
      extent = d3.extent(data, function(d) {
        // don't count overall US total
        if (d.state === 'us') {
          return 0;
        } else {
          return +d.value;
        }
      });
      MapCScale.domain(extent);
      // a "dictionary" of state-counts, accessed by state
      data_dict = data.toDict('state');
      return update(new_label);
    };
    map.get_selected_region = function() {
      return selected_state_ids;
    };
    map.set_selected_region = function(ids_in) {
      var i, j, len;
      selected_state_ids = [];
      if (ids_in) {
        for (j = 0, len = ids_in.length; j < len; j++) {
          i = ids_in[j];
          selected_state_ids.push(i);
        }
      }
      if (states_g) {
        return states_g.selectAll("g").classed('clicked', function(d) {
          var current_id, current_state;
          current_state = this.getAttribute("class").split(" ")[1].toLowerCase();
          current_id = region_to_num[`${current_state}`];
          if (isInArray(current_id, selected_state_ids)) {
            return true;
          } else {
            return false;
          }
        });
      }
    };
    // final act of AdvancedSearchMap() function is to return the inner map function
    return map;
  };

  // Formats the stats
  format_numbers = function(raw_number, num_digits = 1) {
    var number, value;
    if (typeof raw_number !== 'undefined' && raw_number !== (0/0)) {
      //formating for numbers
      number = raw_number * 1;
      number = +number.toFixed(num_digits);
      if (number < 10000) {
        value = number.toString().substr(0, 4);
      } else if (number < 1000000) {
        number = number / 1000;
        value = number.toString().substr(0, 4) + "K";
      } else if (number < 1000000000) {
        number = number / 1000000;
        value = number.toString().substr(0, 4) + "M";
      } else if (number > 1000000000) {
        number = number / 1000000000;
        value = number.toString().substr(0, 4) + "B";
      }
    }
    if (value !== "N/A") {
      if (value.substring(3, 4) != null) {
        if (value.substring(3, 4) === '.') {
          value = value.replace('.', '');
        }
      }
    }
    return value;
  };

  module.exports = {
    ReusableMap: ReusableMap
  };

}).call(globalThis);
